import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Button, Typography, Container } from '@material-ui/core';
import { ComponentsLib } from '@payface-frontends-libs/components';
const { Page, Logo } = ComponentsLib.Generics;
const { MotionContainer } = ComponentsLib.Animate;
const { varBounceIn } = ComponentsLib.Animate;
const RootStyle = styled(Page)(({ theme }) => ({
    display: 'flex',
    minHeight: '100%',
    alignItems: 'center',
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
}));
const HeaderStyle = styled('header')(({ theme }) => ({
    top: 0,
    left: 0,
    lineHeight: 0,
    width: '100%',
    position: 'absolute',
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up('sm')]: { padding: theme.spacing(5, 5, 0) },
}));
export function Page404() {
    return (_jsxs(RootStyle, Object.assign({ title: "404 Page Not Found | Minimal-UI" }, { children: [_jsx(HeaderStyle, { children: _jsx(RouterLink, Object.assign({ to: "/" }, { children: _jsx(Logo, {}, void 0) }), void 0) }, void 0), _jsx(Container, { children: _jsx(MotionContainer, Object.assign({ initial: "initial", open: true }, { children: _jsxs(Box, Object.assign({ sx: { maxWidth: 480, margin: 'auto', textAlign: 'center' } }, { children: [_jsx(motion.div, Object.assign({ variants: varBounceIn }, { children: _jsx(Typography, Object.assign({ variant: "h3", gutterBottom: true }, { children: "Sorry, page not found!" }), void 0) }), void 0), _jsx(Typography, Object.assign({ sx: { color: 'text.secondary' } }, { children: "Sorry, we couldn\u2019t find the page you\u2019re looking for. Perhaps you\u2019ve mistyped the URL? Be sure to check your spelling." }), void 0), _jsx(Box, { component: motion.img, variants: varBounceIn, alt: "404", src: "/static/illustrations/illustration_404.svg", sx: { width: '100%', maxHeight: 240, my: { xs: 5, sm: 10 } } }, void 0), _jsx(Button, Object.assign({ to: "/", size: "large", variant: "contained", component: RouterLink }, { children: "Go to Home" }), void 0)] }), void 0) }), void 0) }, void 0)] }), void 0));
}
//# sourceMappingURL=Page404.js.map